import { render, staticRenderFns } from "./app-role-new.vue?vue&type=template&id=7da6ba27&scoped=true&"
import script from "./app-role-new.vue?vue&type=script&lang=js&"
export * from "./app-role-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da6ba27",
  null
  
)

export default component.exports